import {OfferSwitcher} from "../Card/OfferSwitcher";
import {Product} from "./Product";

export class Remove {
    constructor(element) {
        this.element = element;

        this.setElementClasses();

        this.basketItem = this.element.closest('.' + this.BASKET_ITEM_CLASS);
        this.elementId = this.basketItem.data('item');

        this.process();
    }
    setElementClasses() {
        this.ORDER_CLASS = 'js-order';
        this.EMPTY_ORDER_CLASS = 'js-order-empty';
        this.BASKET_CLASS = 'js-basket';
        this.BAG_DROP_CLASS = 'bag-drop';
        this.BASKET_ITEM_ROW_CLASS = 'js-basket_item-row';
        this.BASKET_ITEM_CLASS = 'js-basket_item';
    }
    process() {
        let $this = this,
            order = $('.' + this.ORDER_CLASS);

        $this.basketItem.preloader('show', 'block');
        $('.' + this.BAG_DROP_CLASS).preloader('show', 'block');

        $.post('/ajax/basket/remove/', {id: this.elementId}, function () {
            window._store.dispatch(window._ActionCreators.removeItemFromBasket(parseInt($this.basketItem.data('id'))));
            $this.removeCallback.call($this);

            $this.add_product_to_mindbox_removed_items_from_cart_list($this.element.data('product-id'), $this.element.data('price'));

            try {
                window.APRT_SEND({
                    pageType: 9,
                    currentProduct: {
                        id: $this.elementId,
                        name: $this.element.data('name'),
                        price: $this.element.data('price')
                    }
                });
            } catch (e) {
            }

        }, 'json');
    }
    removeCallback(order) {
        let alreadyTriggerSent = false;
        const product = Product.fromAttributes(this.basketItem);

        this.basketItem.slideUp(200, function () {
            $(this).remove();

            if (!alreadyTriggerSent) {
                $(window).trigger('mario.basket_item.remove');
                BX.Event.EventEmitter.emit('Mario.Basket:removed',  { product });

                alreadyTriggerSent = true;
            }
        });

        refreshHeaderBasket();
        refreshOffersArray(this.elementId, 'remove', 'block');

        $('.js-offer-switcher').bindToEntity(OfferSwitcher);

        $('.' + this.BAG_DROP_CLASS).preloader('hide', 'block');
    }
    add_product_to_mindbox_removed_items_from_cart_list(id, price) {
        if (id && typeof mindbox != 'undefined') {
            mindbox("async", {
                operation: "AddProductToRemovedItemsFromCartList",
                data: {
                    addProductToList: {
                        product: {
                            ids: {
                                website: id
                            }
                        },
                        pricePerItem: price
                    }
                }
            });
        }
    }
}
